/**
 * hooks/useMediaQuery.js -- `true` mientras `query` coincide con el viewport (se actualiza al redimensionar o girar).
 * Extraído de AppLayout para que cualquier vista que necesite cambiar de CONTENIDO (no solo de estilo) por tamaño
 * comparta una sola implementación. Si basta con cambiar el estilo, usa CSS: este hook es para lo que CSS no resuelve.
 */
import { useEffect, useState } from 'react';

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const media = window.matchMedia(query);
    const change = () => setMatches(media.matches);
    change(); media.addEventListener('change', change);
    return () => media.removeEventListener('change', change);
  }, [query]);
  return matches;
}
